// extracted by mini-css-extract-plugin
export var PageCard = "GrpBlockSearchResult-module--PageCard--642d0";
export var btn = "GrpBlockSearchResult-module--btn--d1a36";
export var buttonTag = "GrpBlockSearchResult-module--buttonTag--c7476";
export var capitalize = "GrpBlockSearchResult-module--capitalize--83ae7";
export var date = "GrpBlockSearchResult-module--date--754ac";
export var dateMobile = "GrpBlockSearchResult-module--dateMobile--9a06a";
export var fs14 = "GrpBlockSearchResult-module--fs-14--93b35";
export var fs16 = "GrpBlockSearchResult-module--fs-16--eddf2";
export var fs20 = "GrpBlockSearchResult-module--fs-20--ba018";
export var fs24 = "GrpBlockSearchResult-module--fs-24--6f129";
export var fs32 = "GrpBlockSearchResult-module--fs-32--7d5c7";
export var fs40 = "GrpBlockSearchResult-module--fs-40--d05bc";
export var fsItalic = "GrpBlockSearchResult-module--fs-italic--697b2";
export var fsLg = "GrpBlockSearchResult-module--fs-lg--0fcd4";
export var fsMd = "GrpBlockSearchResult-module--fs-md--3b16a";
export var fsNormal = "GrpBlockSearchResult-module--fs-normal--befdc";
export var fsSm = "GrpBlockSearchResult-module--fs-sm--9b88c";
export var fsXl = "GrpBlockSearchResult-module--fs-xl--d5ab5";
export var fsXs = "GrpBlockSearchResult-module--fs-xs--ad0ec";
export var fsXxl = "GrpBlockSearchResult-module--fs-xxl--dcf6c";
export var fsXxs = "GrpBlockSearchResult-module--fs-xxs--21fcd";
export var fwBold = "GrpBlockSearchResult-module--fw-bold--9d2c9";
export var fwMedium = "GrpBlockSearchResult-module--fw-medium--09236";
export var fwNormal = "GrpBlockSearchResult-module--fw-normal--b36b6";
export var gotham_bold = "GrpBlockSearchResult-module--gotham_bold--a8471";
export var gotham_bold_italic = "GrpBlockSearchResult-module--gotham_bold_italic--507aa";
export var gotham_book = "GrpBlockSearchResult-module--gotham_book--c74e5";
export var gotham_book_italic = "GrpBlockSearchResult-module--gotham_book_italic--8b891";
export var icon = "GrpBlockSearchResult-module--icon--f1742";
export var iconContainer = "GrpBlockSearchResult-module--iconContainer--bb5d5";
export var img = "GrpBlockSearchResult-module--img--63195";
export var lowercase = "GrpBlockSearchResult-module--lowercase--09cb8";
export var pageContent = "GrpBlockSearchResult-module--pageContent--6d779";
export var seeMoreButton = "GrpBlockSearchResult-module--seeMoreButton--bd896";
export var tag = "GrpBlockSearchResult-module--tag--85a32";
export var tagMobile = "GrpBlockSearchResult-module--tagMobile--882e9";
export var tagsContainer = "GrpBlockSearchResult-module--tagsContainer--1763c";
export var tagsMobile = "GrpBlockSearchResult-module--tagsMobile--a72de";
export var tagsSwiper = "GrpBlockSearchResult-module--tagsSwiper--e2973";
export var uppercase = "GrpBlockSearchResult-module--uppercase--9c906";